<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-danger py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Choose the best plan for your business</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-secondary" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="10">
          <b-card-group class="pricing flex-column flex-md-row mb-3">
            <card header-classes="bg-transparent"
                  body-classes="px-lg-5"
                  class="card-pricing border-0 mb-4">
              <h4 slot="header" class="text-uppercase ls-1 text-danger py-3 mb-0 text-center">Lead Yourself</h4>

              <div class="display-5 text-center">$79 / Month</div>
              <div class="text-center text-muted my-4">
                1 Agent<br />
                + <br />
                Admins FREE
              </div>

              <base-button block type="danger" class="mb-3">REGISTER NOW</base-button>
            </card>

            <card gradient="danger"
                  class="card-pricing zoom-in shadow-lg rounded border-0 mb-4"
                  header-classes="bg-transparent"
                  body-classes="px-lg-4"
                  footer-classes="bg-transparent"
            >
              <h4 slot="header" class="text-uppercase ls-1 text-white py-3 mb-0 text-center">Lead Others</h4>

              <div class="display-4 text-center text-white">$99 / Month</div>
              <div class="text-center text-white my-4">
                2-4 Agents<br />
                + <br />
                Admins FREE
              </div>

              <div class="text-center">
                <base-button block type="white" class="mb-3">REGISTER NOW</base-button>
              </div>
            </card>

            <card header-classes="bg-transparent"
                  body-classes="px-lg-5"
                  class="card-pricing border-0 text-center mb-4">
              <h4 slot="header" class="text-uppercase ls-1 text-danger py-3 mb-0">Create Leaders</h4>

              <div class="display-5">$199 / Month</div>
              <div class="text-center text-muted my-4">
                5+ Agents<br />
                + <br />
                Admins FREE
              </div>

              <base-button block type="danger" class="mb-3">REGISTER NOW</base-button>
            </card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
export default {
  name: 'pricing-page'
};
</script>
<style></style>
